// Şirket bilgileri
export const COMPANY_INFO = {
  name: "SGT DIŞ TİCARET LTD. ŞTİ.",
  shortName: "SGT Global Trade",
  tagline: {
    tr: "Dünya Ticaretinde Güvenilir Ortağınız",
    en: "Your Reliable Partner in Global Trade",
  },
  address: {
    tr: "İnkılap Mh. Seyit Onbaşı Cd. No: 7/A Ümraniye / İstanbul",
    en: "Inkilap District, Seyit Onbasi Street No: 7/A Umraniye / Istanbul, Turkey",
  },
  email: "info@sgttr.com",
  phone: "+90 533 399 2188",
  workingHours: {
    tr: "09:00 - 18:00 (Haftanın 7 günü)",
    en: "09:00 - 18:00 (7 days a week)",
  },
};

// Ürün listesi
export const PRODUCTS = [
  {
    id: "wheat",
    nameKey: "products.wheat",
    image: "/images/products/wheat.jpg",
    detailRoute: "/products/wheat",
  },
  {
    id: "barley",
    nameKey: "products.barley",
    image: "/images/products/barley.jpg",
    detailRoute: "/products/barley",
  },
  {
    id: "corn",
    nameKey: "products.corn",
    image: "/images/products/corn.jpg",
    detailRoute: "/products/corn",
  },
  {
    id: "corn-oil",
    nameKey: "products.cornOil",
    image: "/images/products/corn-oil.jpg",
    detailRoute: "/products/corn-oil",
  },
  {
    id: "sunflower-oil",
    nameKey: "products.sunflowerOil",
    image: "/images/products/sunflower-oil.jpg",
    detailRoute: "/products/sunflower-oil",
  },
  {
  id: "chicken",
  nameKey: "products.chicken",
  image: "/images/products/chicken.jpg",
  detailRoute: "/products/chicken",
  },
  {
    id: "fertilizer",
    nameKey: "products.fertilizer",
    image: "/images/products/fertilizer.jpg",
    detailRoute: "/products/fertilizer",
  },
];

// Ana Sayfa Slider içeriği
export const HOME_SLIDER = [
  {
    id: 1,
    image: "/images/slider/slide1.jpg",
    title: {
      tr: "Kaliteli Tahıl Ürünleri",
      en: "Quality Grain Products",
    },
    description: {
      tr: "Dünya standartlarında tarım ürünleri tedarikçiniz",
      en: "Your supplier of world-class agricultural products",
    },
  },
  {
    id: 2,
    image: "/images/slider/slide2.webp",
    title: {
      tr: "Premium Bitkisel Yağlar",
      en: "Premium Vegetable Oils",
    },
    description: {
      tr: "Yüksek kaliteli, saf bitkisel yağ çözümleri",
      en: "High quality, pure vegetable oil solutions",
    },
  },
  {
    id: 3,
    image: "/images/slider/slide3.webp",
    title: {
      tr: "Güvenilir Tedarik Zinciri",
      en: "Reliable Supply Chain",
    },
    description: {
      tr: "Güvenli sevkiyat ve zamanında teslimat garantisi",
      en: "Secure shipping and on-time delivery guarantee",
    },
  },
];
